import { useMutation, useQueryClient } from "@tanstack/react-query"
import { generateQRCodeForTwoFa, verifyOTPForTwoFa } from "../api/two-fa"
import { AUTH_USER_KEY } from "./useAuth"

export const useGenerateQRCode = () =>
  useMutation({
    mutationFn: generateQRCodeForTwoFa,
  })

export const useVerifyOTP = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: verifyOTPForTwoFa,
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: AUTH_USER_KEY })
    },
  })
}
